import { adColumnPreviewStyle } from '@bingads-webui-campaign-react/common-styles';

export const getBulkEditOverrideStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .campaigns-date-picker .radioInput .date': {
    marginRight: '5px',
  },
  '& select.form-control.custom-param__select': {
    marginBottom: '5px',
  },
  '& .bulkEdit-limit-label.checkbox-inline': {
    paddingTop: '0px',
    paddingBottom: '0px',
  },
  '& .control-label': {
    verticalAlign: 'middle',
    display: 'inline-block',

    '&.bulk-edit-currency': {
      paddingTop: '0px',
      paddingBottom: '0px',
    },
    '&#currencyLabel1': {
      paddingTop: '0px',
    },
  },
  '& span.control-label.not(#bulkedit-budget-label)': {
    paddingTop: '0px',
  },
  '& .infomark.spritedimage': {
    fontStyle: 'normal',
    fontSize: '16px',
    verticalAlign: 'middle',
    marginRight: '5px',

    '&:before': {
      fontFamily: iconFontFamily,
      content: '"\\F167"',
    },
  },
  '& .form-horizontal .form-group': {
    marginLeft: '0px',
    marginRight: '0px',
  },
  '& .previewTable': {
    padding: '15px',
    overflowY: 'auto',
  },
  '& .previewTable > table': {
    borderLeft: 'none',
    borderRight: 'none',
  },
  '& .previewTable > table td, & .previewTable > table th': {
    border: '1px solid',
    borderColor: palette.neutralLighter,
    borderLeft: 'none',
    height: '44px',
    padding: '0px 8px',
  },
  '& .previewTable > table tr td:last-child, & .previewTable > table tr th:last-child': {
    borderRight: 'none',
  },
  '& .previewTable > table tr td': {
    color: ' #797775',
    fontSize: '12px',
  },
  '& .previewTable > table tr th a': {
    color: palette.neutralPrimary,
    fontWeight: 'normal',
    cursor: 'unset',
  },
  '& label > input[type="radio"]': {
    marginRight: '5px',
    position: 'relative',
  },
  '& .campaigns-date-picker input[type="radio"]': {
    position: 'relative',
  },
  '& .campaigns-date-picker .radioInput label': {
    display: 'inline-block',
  },
  '& .campaigns-date-picker .radioInput': {
    display: 'flex',
    alignItems: 'center',
    '& .nodate, & .date': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  '& .form-inline .form-control, & .form-inline .form-text': {
    marginRight: '10px',
  },
  '& .font-error': {
    color: palette.redDark,
  },
  '& .error': {
    color: palette.redDark,
  },
  '& input.btn, & button.btn': {
    marginRight: '8px',
  },
  // bulk edit bid strategy type
  '& .bid-strategy-container label': {
    display: 'inline-block',
  },
  '& [data-bind="visible: checkCPC"] > .row': {
    marginLeft: '0px',
  },
  '& [data-bind="visible: showCPC"]': {
    '& > label, & > a[type="helppopup"]': {
      display: 'inline-block',
    },
  },
  '& .builkEdit-bid.custom-param__key-field, & .target-impression-share-percent-field.custom-param__key-field': {
    display: 'inline-block',
    marginLeft: 5,
    marginRight: 5,
    width: 85,
  },
  '& .grid-content-container': {
    fontSize: 14,
    lineHeight: '19px',
    color: palette.neutralPrimary,
    // Bulk change ads.
    ...adColumnPreviewStyle(),
  },
  '& .grid-content-container .previewAd': {
    border: '1px solid #ccc',
    padding: 5,
    margin: [5, 0, 5, 0],
  },
  '& .grid-content-container .previewAd .previewTitleAd + div + div, & .grid-content-container .previewAd .moreHint + div + span': {
    color: '#767676',
  },
  '& .panel > .panel-body > .form-group': {
    '&  > .rsa-headlines, & > .rsa-descriptions, & > .mma-headlines, & > .mma-descriptions': {
      width: '100%',
      paddingLeft: 0,
      paddingRight: 0,
      '& .glyphicon-pushpin, & .glyphicon-plus': {
        color: palette.themePrimary,
        fontFamily: iconFontFamily,
      },
      '& .glyphicon-pushpin:before': {
        content: '"\\E840"',
      },
      '& .glyphicon-plus:before': {
        content: '"\\E710"',
        marginRight: 8,
      },
      '& .form-group': {
        margin: 0,
      },
      '& .control-label': {
        width: '16.66666667%',
        '& > label': {
          display: 'inline-block',
        },
        '& > helpbutton': {
          display: 'inline-block',
        },
      },
      '& .ad-rsa-filed-group': {
        width: '41.666666667%',
        '& > .form-control.text': {
          width: '90%',
          display: 'inline-block',
        },
        '& > .ad-rsa-pin-group': {
          display: 'inline-flex',
          width: '10%',
          '& > .ad-field-position': {
            display: 'inline',
            paddingLeft: 12,
            '& > .glyphicon-pushpin': {
              display: 'inline',
            },
            '& > .ad-pinned': {
              display: 'inline',
              paddingLeft: 8,
              color: palette.neutralPrimary,
              wordBreak: 'keep-all',
            },
          },
        },
        '& > .clearfix': {
          marginRight: '10%',
          textAlign: 'right',
          marginBottom: 11,
        },
      },
      '& .ad-rsa-add-headline, & .ad-rsa-add-description': {
        marginLeft: '16.66666667%',
        paddingLeft: 15,
        color: palette.neutralPrimary,
      },
      '& .ad-rsa-add-headline.disabled, & .ad-rsa-add-description.disabled': {
        color: palette.neutralTertiary,
        paddingLeft: 15,
        cursor: 'default',
        '& .glyphicon-plus': {
          color: palette.neutralTertiary,
        },
      },
    },
  },
  // Bulk appeal.
  '& .bulk-appeal .editor .form-horizontal': {
    margin: 0,
    maxWidth: 784,
    border: 0,
    boxShadow: 'none',
    '& .form-group': {
      margin: '0px 0px 18px 0px',
      '& .root': {
        margin: 0,
        padding: 0,
        '& > label': {
          padding: 0,
        },
        '& .title': {
          fontWeight: 'normal',
        },
        '& .details': {
          margin: '27px 0px 0px 0px',
          padding: 0,
          '& .col-sm-4': {
            padding: '0px 0px 0px 1px',
            width: '50%',
            '& .appeal-column-title': {
              fontSize: 18,
              lineHeight: '24px',
              fontWeight: 'normal',
            },
            '& .reasons > ul': {
              margin: '1px 0px 0px 0px',
              '& > li': {
                marginTop: '10px',
              },
            },
          },
          '& .col-sm-8': {
            width: '50%',
            paddingLeft: 14,
            paddingRight: 0,
            '& .appeal-column-title': {
              fontSize: 14,
              lineHeight: '19px',
              fontWeight: 600,
            },
            '& .appeal-textarea': {
              marginTop: 7,
              padding: 8,
              fontSize: 14,
              lineHeight: '19px',
              border: `1px solid ${palette.neutralSecondary}`,
              borderRadius: '2px',
              background: '#FFFFFF',
              width: '100%',
            },
            '& .remaining-hint': {
              textAlign: 'right',
              marginTop: 3,
              marginBottom: 3,
              fontSize: 12,
              lineHeight: '16px',
            },
          },
        },
        '& .non-appeal-msg-panel': {
          margin: '11px 0px 0px 1px',
        },
      },
    },
  },
  '& .rsa-auto-assets-setting-container': {
    '& .checkbox-inline': {
      width: '100%',
      '& input': {
        float: 'left',
        bottom: '0',
      },
    },
    '& .HelpTopic': {
      marginLeft: 5,
    },
  },
  '& #status-label': {
    color: '#0A610A',
    backgroundColor: '#DFF6DD',
    fontWeight: 600,
    fontSize: 12,
    border: 4,
    paddingInline: 5,
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: 2,
    paddingRight: 2,
    verticalAlign: 'middle',
    borderRadius: 4,
    marginLeft: 8,
  },
});
